import BillResumeCard from "./BillResumeCard";

export default BillResumeCard;
